function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M2 18h16V2H2z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.744 12.63c-.158.442-.916.844-1.28.898-.326.049-.74.068-1.195-.075a10.9 10.9 0 0 1-1.08-.398c-1.903-.817-3.145-2.723-3.24-2.85-.094-.126-.774-1.023-.774-1.952s.49-1.385.664-1.574a.697.697 0 0 1 .505-.236c.126 0 .253.001.364.006.116.006.273-.044.426.324.158.378.537 1.307.584 1.402.047.094.078.205.016.33-.063.126-.094.205-.19.315-.094.11-.198.246-.283.33-.095.095-.194.197-.083.386.11.19.49.807 1.054 1.308.724.643 1.336.842 1.525.937.189.094.3.078.41-.047.111-.127.475-.551.6-.74.127-.19.253-.158.427-.095.173.063 1.106.52 1.295.614.19.094.316.142.364.22.047.079.049.457-.11.898zm1.924-8.304A7.936 7.936 0 0 0 10.032 2C5.64 2 2.066 5.558 2.064 9.93c0 1.34.34 2.66.985 3.827l-1.035 3.765c-.037.13 0 .27.096.366a.382.382 0 0 0 .366.1l3.88-1.014a8.022 8.022 0 0 0 3.676.895c4.392 0 7.966-3.558 7.968-7.932 0-2.119-.828-4.112-2.332-5.611z",
  mask: "url(#b)"
}));

var SvgWhatsapp = function SvgWhatsapp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp.8e232b8c.svg";
export { ForwardRef as ReactComponent };